<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>To Doreen and John and Baby Westermark, with lots of love and best wishes.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter.vue?08ad4af0